import css from './PrefixInput.module.css'

interface PrefixInputProps {
    prefix: string
    id?: string
    value?: string
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
    placeholder?: string
    disabled?: boolean
    maxLength?: number
    error?: boolean
}

const PrefixInput = ({ prefix, id, value, onChange, onBlur, onKeyDown, placeholder, disabled = false, maxLength, error = false }: PrefixInputProps) => {
    return (
        <div className={`${css.wrapper}${error ? ` ${css.error}` : ''}`}>
            <span className={css.prefix}>{prefix}</span>
            <input
                id={id}
                type="text"
                className={css.input}
                autoComplete="none"
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                placeholder={placeholder}
                disabled={disabled}
                maxLength={maxLength}
            />
        </div>
    )
}

export default PrefixInput
